var _rect, _path, _path2, _path3, _path4, _rect2, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCastVoteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 77,
  height: 76,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 76,
  height: 76,
  rx: 38,
  fill: "#25262B"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 43h46v12a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4V43Z",
  fill: "#5D5F65"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m39.755 50.994 1.134 1.146a.337.337 0 0 1 0 .5l-.25.25a.337.337 0 0 1-.499 0l-1.134-1.135-1.146 1.134a.337.337 0 0 1-.5 0l-.25-.25a.337.337 0 0 1 0-.499l1.135-1.146-1.134-1.134a.337.337 0 0 1 0-.5l.25-.25a.337.337 0 0 1 .499 0l1.146 1.135 1.134-1.134a.337.337 0 0 1 .5 0l.25.25a.337.337 0 0 1 0 .499l-1.135 1.134Z",
  fill: "#EF8D8A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.821 33.852A4 4 0 0 1 25.196 32h26.767a4 4 0 0 1 3.235 1.647L62 43H16l5.821-9.148Z",
  fill: "#383A3F"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M27 20a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v18H27V20Z",
  fill: "#909296"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 2,
  rx: 1,
  transform: "matrix(1 0 0 -1 24 39)",
  fill: "#25262B"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M39.011 27.485c1.852 0 4.5 2.883 4.5 4.711 0 .82-.632 1.29-1.687 1.29-1.148 0-1.898-.587-2.813-.587-.937 0-1.687.586-2.836.586-1.054 0-1.663-.469-1.663-1.289 0-1.828 2.624-4.711 4.5-4.711Zm-3.468-.281c.258.82-.117 1.593-.797 1.758-.68.164-1.43-.352-1.664-1.172-.258-.82.117-1.594.797-1.758.68-.164 1.43.352 1.664 1.172Zm1.992-.492c-.727.187-1.547-.47-1.828-1.5-.258-1.008.093-1.993.82-2.18.727-.188 1.547.469 1.828 1.5.258 1.008-.093 1.992-.82 2.18Zm6.586-.68c.68.164 1.054.937.797 1.758-.235.82-.985 1.336-1.664 1.172-.68-.165-1.055-.938-.797-1.758.234-.82.984-1.336 1.664-1.172Zm-3.656.68c-.727-.188-1.079-1.172-.82-2.18.28-1.031 1.1-1.688 1.827-1.5.727.187 1.078 1.172.82 2.18-.28 1.03-1.1 1.687-1.827 1.5Z",
  fill: "#383A3F"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m24.694 52.922-1.62-1.739a.293.293 0 0 1 0-.387l.35-.377a.236.236 0 0 1 .352 0l1.104 1.173 2.344-2.514a.236.236 0 0 1 .351 0l.352.377a.293.293 0 0 1 0 .388l-2.871 3.078a.247.247 0 0 1-.362 0Z",
  fill: "#75CC72"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M54.643 51c.19 0 .357.156.357.333v.334c0 .187-.167.333-.357.333h-4.286c-.2 0-.357-.146-.357-.333v-.334c0-.177.156-.333.357-.333h4.286Z",
  fill: "#CFD4D9"
})));
export default SvgCastVoteIcon;